import { render, staticRenderFns } from "./StackOrderModalHeader.vue?vue&type=template&id=4d779a91&"
import script from "./StackOrderModalHeader.vue?vue&type=script&lang=ts&"
export * from "./StackOrderModalHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports